var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 46,
    viewBox: "0 0 136 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2969 30.3438V34H59.1875V30.3438H71.2969ZM60.7188 11.25V34H56.0312V11.25H60.7188ZM69.7188 20.5156V24.0781H59.1875V20.5156H69.7188ZM71.2812 11.25V14.9219H59.1875V11.25H71.2812ZM88.6562 30.3438V34H77.2031V30.3438H88.6562ZM78.7188 11.25V34H74.0312V11.25H78.7188ZM106.609 30.3438V34H94.5V30.3438H106.609ZM96.0312 11.25V34H91.3438V11.25H96.0312ZM105.031 20.5156V24.0781H94.5V20.5156H105.031ZM106.594 11.25V14.9219H94.5V11.25H106.594ZM111.484 11.25H115.453L121.297 27.9531L127.141 11.25H131.109L122.891 34H119.703L111.484 11.25ZM109.344 11.25H113.297L114.016 27.5312V34H109.344V11.25ZM129.297 11.25H133.266V34H128.578V27.5312L129.297 11.25Z",
    fill: "#637B96"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9906 44.8601C35.0856 44.8601 44.8907 35.07 44.8907 22.992C44.8907 10.9139 35.0856 1.12519 22.9906 1.12519C10.8957 1.12519 1.09129 10.9153 1.09129 22.9933C1.09129 35.0713 10.8957 44.8601 22.9906 44.8601ZM22.9906 45.9826C35.7068 45.9826 46.0155 35.6896 46.0155 22.992C46.0155 10.2943 35.7068 0 22.9906 0C10.2745 0 -0.0335312 10.2957 -0.0335312 22.9933C-0.0335312 35.6909 10.2745 45.9839 22.9906 45.9839V45.9826Z",
    fill: "#667B9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9906 0.58477C35.3663 0.58477 45.3956 10.6176 45.3956 22.9933C45.3956 35.3691 35.3663 45.4012 22.9906 45.4012C10.6149 45.4012 0.582893 35.3691 0.582893 22.9933C0.582893 10.6176 10.6156 0.58477 22.9906 0.58477Z",
    fill: "#667B9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45948 9.53265C7.40499 10.0268 13.4213 13.2012 17.0825 15.8057C24.143 20.8288 32.5599 27.7731 38.781 17.5585C40.2537 15.1445 40.8077 12.3818 40.9387 11.6234C37.0948 5.66623 30.4668 1.73008 22.9335 1.73008C16.3183 1.73008 10.4088 4.76098 6.45948 9.53265Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe090d6de8289a2794f70d32bb824ad0.svg";
export { ForwardRef as ReactComponent };